
export const colorNormalize = (source) => {
    return {
        idColor: source.idColor ?? source.IdColor ?? 0,
        nombre: source.nombre ?? source.Nombre ?? '',
        descripcion: source.descripcion ?? source.Descripcion ?? '',
        idCatColor: source.idCatColor ?? source.IdCatColor ?? 0,
        variable: source.variable ?? source.Variable ?? '',
        valor: source.valor ?? source.Valor ?? '',
        activo: source.activo ?? source.Activo ?? false,
        idCategoria: source.idCategoria ?? source.IdCategoria ?? null,
        nombreCategoria: source.nombreCategoria ?? source.NombreCategoria ?? ''
    }
}

export const catColorNormalize = (source) => {
    return {
        idColor: source.idColor ?? source.IdColor ?? 0,
        nombre: source.nombre ?? source.Nombre ?? '',
        variable: source.variable ?? source.Variable ?? '',
        activo: source.activo ?? source.Activo ?? false
    }
}
